<template>
  <div class="page">
    <c-source-page
      :columns="columns"
      :filter="filter"
      :table="table"
      :pagination="pagination"
      resource="order_commissions"
      exportExcelURL="/order_commissions/resource.xlsx"
    />
  </div>
</template>

<script type="text/javascript">
import { Vue, Component } from 'vue-property-decorator';
import createColumns from './columns';
import { ORDER_COMMISSION_STATUS } from '@/constants';
import _ from 'lodash';

@Component
export default class OrderCommissions extends Vue {
  table = { data: [] }
  totalAmount = 0;
  pagination = {}

  filter = [
    {
      prop: 'user_no_cont',
      label: '邀请者唯一编号',
      form: {
        component: 'input'
      }
    },
    {
      prop: 'user_nickname_cont',
      label: '邀请者昵称',
      form: {
        component: 'input'
      }
    },
    {
      prop: 'invitee_no_cont',
      label: '消费者唯一编号',
      form: {
        component: 'input'
      }
    },
    {
      prop: 'invitee_nickname_cont',
      label: '消费者昵称',
      form: {
        component: 'input'
      }
    },
    {
      prop: 'status_in',
      label: '状态',
      form: {
        component: 'select',
        props: {
          multiple: true,
          options: _.map(ORDER_COMMISSION_STATUS, (label, value) => ({ label, value }))
        }
      }
    },
    {
      prop: 'created_at_gteq_datetime',
      label: '创建时间 - 开始时间',
      form: {
        component: 'datePicker'
      }
    },
    {
      prop: 'created_at_lteq_datetime',
      label: '创建时间 - 结束时间',
      form: {
        component: 'datePicker'
      }
    },
  ]

  get columns() {
    return createColumns();
  }

  async mounted() {
    this.fetchData();
  }

  async fetchData(params = {}) {
    const { data, pagination } = await this.$request.get('/order_commissions', { params: { ...this.$route.query, ...params } });
    this.table.data = data.commissions;
    this.totalAmount = data.total_amount;
    this.pagination = pagination;

    await this.$nextTick();
    let totalAmountEl = this.$el.querySelector('.order-commissions-total-amount');
    if (!totalAmountEl) {
      totalAmountEl = document.createElement('div');
      totalAmountEl.classList.add('order-commissions-total-amount');
    }
    totalAmountEl.innerHTML = `佣金金额总计： <strong>${this.totalAmount} </strong>`;
    this.$el.querySelector('.c-source-table').parentNode.insertBefore(totalAmountEl, document.querySelector('.c-source-table'));
  }

  beforeDestroy() {
    const totalAmountEl = this.$el.querySelector('.order-commissions-total-amount');
    if (totalAmountEl) {
      totalAmountEl.remove();
    }
  }
}
</script>

<style lang="scss">
  .order-commissions-total-amount {
    font-size: 16px;
    padding-bottom: 5px;
  }
</style>

